var allStoreData_api = "https://as-handt-store-address-service.azurewebsites.net/api/AllStoreData";
var nearestShop_api = "https://as-handt-store-address-service.azurewebsites.net/api/NearestStore";
//var drivingDistance_api = "https://as-handt-store-address-service.azurewebsites.net/api/DrivingDistance";
//var embedMap_api = "https://as-handt-store-address-service.azurewebsites.net/api/EmbedMap/6120";
//const allRegionCords = [];
const allRegionCords = [
    {"storeName": "Scotland", "storeLatitude": "55.862982", "storeLongitude": "-4.267435"},
    {"storeName": "North East", "storeLatitude": "55.078367", "storeLongitude": "-1.950096"},
    {"storeName": "North West", "storeLatitude": "54.046489", "storeLongitude": "-2.642094"},
    {"storeName": "Yorkshire and Humber", "storeLatitude": "53.729217", "storeLongitude": "-0.368062"},
    {"storeName": "East Midland", "storeLatitude": "52.99495", "storeLongitude": "-1.235836"},
    {"storeName": "West Midland", "storeLatitude": "52.476089", "storeLongitude": "-1.916996"},
    {"storeName": "East of England", "storeLatitude": "52.562995", "storeLongitude": "0.972056"},
    {"storeName": "London", "storeLatitude": "51.501904", "storeLongitude": "-0.11526"},
    {"storeName": "South East London", "storeLatitude": "51.548043", "storeLongitude": "0.187455"},
    {"storeName": "South West London", "storeLatitude": "51.25418", "storeLongitude": "-0.056969"},
    {"storeName": "Wales", "storeLatitude": "52.321911", "storeLongitude": "-3.883434"}
  ]
var allStoresData = {}

$(document).on('click', '#submit', function(){
  let shop_id = $('#postcode').val();
  if(shop_id != ''){
    nearestShop(shop_id)
  }
})

$(document).on('keypress',function(e) {
  if(e.which == 13) {
    let shop_id = $('#postcode').val();
    if(shop_id != ''){
      nearestShop(shop_id)
    }
  }
});

//toggle result view
$(document).on('click', '#list-view', function(){
  $(this).addClass('active');
  $('#map-view').removeClass('active');
  $('.col-store-map').hide();
  $('.col-store-list').show();
})
$(document).on('click', '#map-view', function(){
  $(this).addClass('active');
  $('#list-view').removeClass('active');
  $('.col-store-list').hide();
  $('.col-store-map').show();
})

$(document).on('click', '#all_stores_list .item:not(.active)', function(){
  $('.store-locator-container').addClass('loading');
  //console.log($(this).attr('data-title'))
  let areaName = $(this).attr('data-title');
  //console.log("allStoresData: ",allStoresData)
  var filteredStoredData = allStoresData.filter(function(item){
    return item[0] == areaName
  })
  //console.log("filteredStoredData: ",filteredStoredData[0][1])
  allStoresListMarker(filteredStoredData[0][1], 7)
})

$(document).on('click', '#all_stores_list .item.active .title', function(){
  $('.store-locator-container').addClass('loading');
  $('#postcode').val('');
  //loading back all areas map  
  allStoresListMarker(allRegionCords, 6, true)
})

//calling sll_stores methods
if($('#all_stores_list').length > 0){
  all_stores();  
  //loading all areas map
  //console.log("allRegionCords: ",allRegionCords)  
  allStoresListMarker(allRegionCords, 6, true)
}

//back to all button action
$('.all-store-back').click(function(){ 
  $('#postcode').val('');
  $('#search_stores_result').hide();
  $('#search_stores_result .store-results.results').html(''); 
  all_stores();
  allStoresListMarker(allRegionCords, 6, true)
})


//find neared stores
function nearestShop(shop_id) {
  var settings = {
    "async": true,
    "crossDomain": true,
    "url": nearestShop_api+'/'+shop_id,
    "method": "GET"
  } 
  $.ajax(settings).done(function (response) {
    if(response.length > 0){      
      $('.stores-count-result').text(response.length);
      bindStoreList(response);
      allStoresListMarker(response, 12);
      if($(window).width() < 750){
        $('.toggle-view').css('display','flex');
      }
    }
  });
}

// all_stores_list
function all_stores(){
  let url = $(document).find('#all_stores_list').attr('data-url');
  console.log("url: ",url)
  var settings = {
    "async": true,
    "crossDomain": true,
    "url": url,
    "method": "GET"
  }
  $.ajax(settings).done(function (response) {
    allStoresData = {};
    response.forEach(item => {
     if (!allStoresData[item.storeArea]) allStoresData[item.storeArea] = []
     allStoresData[item.storeArea].push(item)   
    })
    allStoresData = Object.entries(allStoresData);    
    //console.log("allStoresData 2: ",allStoresData)
    $(document).find('#all_stores_list .toggle-list').html('');
    for (let index = 0; index < allStoresData.length; index++) {
      let storeData = '';     
      let areaName = allStoresData[index][0];
      let areaLists = [];
      let obj = allStoresData[index][1];
      let counter = 0;    
      for (let i = 0; i < obj.length; i++) {
        var storeHandle = obj[i].storeName;
        storeHandle = storeHandle.toLowerCase().trim();
        storeHandle = storeHandle.replaceAll(' ','-').replace("(","").replace(")","").replace(".","");
        counter++;
        storeData += 
        `<div class="card-body body-1" id="`+obj[i].storeNumber+`">
          <div class="map-marker"><span>`+counter+`</span></div>            
          <div class="store-details" data-store-id="`+obj[i].storeNumber+`">
            <!--a href="/pages/`+storeHandle+`?id=`+obj[i].storeNumber+`" title="`+obj[i].storeName+`" tabindex="0"-->
            <a href="/pages/`+storeHandle+`" title="`+obj[i].storeName+`" tabindex="0">
              <div class="store-name" data-latitude="`+obj[i].storeLatitude+`" data-longitude="`+obj[i].storeLongitude+`">                  
                `+obj[i].storeName+`  
                <span class="text-red view-store-link">View</span>
              </div>
            </a>
            <address>
              <div class="store-map">`+obj[i].storeAddress+`, `+obj[i].storePostcode+`</div>
              <!--div class="store-distance store-distance-1">
                <span class="distance-miles">`+obj[i].distanceFromTarget+`</span>
                <span>miles away</span>
              </div-->
              <!--div class="store-hours">Opening Hours: `+obj[i].monday+`</div-->
              <!--a href="/pages/store-details?id=`+obj[i].storeNumber+`" class="text-red">View</a-->
              <a class="store-contact" href="tel:`+obj[i].storeTelephone1+`"><i class="fa fa-phone"></i> `+obj[i].storeTelephone1+`</a>
            </address>
          </div>
        </div>`;
      }
      var toggleListItem = `<li class="item" data-title="`+areaName+`"><h5 class="title">`+areaName+`</h5><div class="answer" style="display: none;"><div class="box-block-container custom-scrollbar">`+storeData+`</div></div></li>`;
      $(document).find('#all_stores_list .toggle-list').append(toggleListItem);
    }
    $('#all_stores_list').show();
    $('#search_stores_result').hide();
    $('#all_stores_list').show();
    $('#search_stores_result').hide();
    //console.log(response)
  })
}

//embed markers in map
function allStoresListMarker(locations, z, cords){
  //console.log("locations: ",locations)
  $('.store-locator-container').addClass('loading');
  var centerCords = {lat: locations[0].storeLatitude, lng: locations[0].storeLongitude}
  if(cords === true){
    //for all area listings
    centerCords = {lat: 53.381130, lng: -1.470085}
  }
  var grayStyles = [
      {
        "elementType": "geometry",
        "stylers": [
          {
            "color": "#e5eafa"
          }
        ]
      },
      {
        "featureType": "landscape",
        "elementType": "labels",
        "stylers": [
          {
            "visibility": "off"
          }
        ]
      },
      {
        "featureType": "poi",
        "stylers": [
          {
            "visibility": "off"
          }
        ]
      },
      {
        "featureType": "road",
        "elementType": "geometry",
        "stylers": [
          {
            "visibility": "simplified"
          }
        ]
      },
      {
        "featureType": "road",
        "elementType": "geometry.fill",
        "stylers": [
          {
            "color": "#b19459"
          }
        ]
      },
      {
        "featureType": "road",
        "elementType": "geometry.stroke",
        "stylers": [
          {
            "color": "#b19459"
          }
        ]
      },
      {
        "featureType": "road",
        "elementType": "labels",
        "stylers": [
          {
            "visibility": "off"
          }
        ]
      },
      {
        "featureType": "road.arterial",
        "stylers": [
          {
            "visibility": "off"
          }
        ]
      },
      {
        "featureType": "road.local",
        "stylers": [
          {
            "visibility": "off"
          }
        ]
      },
      {
        "featureType": "transit",
        "stylers": [
          {
            "visibility": "off"
          }
        ]
      },
      {
        "featureType": "water",
        "elementType": "geometry.fill",
        "stylers": [
          {
            "color": "#7e8db2"
          }
        ]
      }
    ]
  var map = new google.maps.Map(document.getElementById('map'), {
    styles: grayStyles,
    zoom: z,
    center: centerCords,
    mapTypeId: google.maps.MapTypeId.ROADMAP
  });    
  var infowindow = new google.maps.InfoWindow();
  var image = "https://cdn.shopify.com/s/files/1/0592/4592/0393/files/marker.png?v=1703080201";
  var marker, i;    
  for (i = 0; i < locations.length; i++) {    
    marker = new google.maps.Marker({
      position: new google.maps.LatLng(locations[i].storeLatitude, locations[i].storeLongitude),
      map: map,
      icon: image
    }); 
    google.maps.event.addListener(marker, 'click', (function(marker, i) {
      return function() {
        if(locations[i].storeNumber == undefined){          
          infowindow.setContent(locations[i].storeName); 
        }
        else{
          var storeHandle = locations[i].storeName;
          storeHandle = storeHandle.toLowerCase().trim();
          storeHandle = storeHandle.replaceAll(' ','-');
          console.log("location storeHandle: ",storeHandle)
          infowindow.setContent('<a data-lang="'+locations[i].storeLatitude+'" data-log="'+locations[i].storeLongitude+'" href="/pages/'+storeHandle+'?id='+locations[i].storeNumber+'">'+locations[i].storeName+'</a>');
        }
        infowindow.open(map, marker);
      }
    })(marker, i));
  }
  $('#map').css('height','626px');
  $('.store-locator-container').removeClass('loading');
}

//bind store list
function bindStoreList(response){
  let counter = 0;
  $('.results').html('');
  for(var key in response){
    var obj = response[key];
    //console.log(obj.storeName)
    counter++;
    var storeHandle = obj.storeName;
    storeHandle = storeHandle.toLowerCase().trim();
    storeHandle = storeHandle.replaceAll(' ','-').replace("(","").replace(")","").replace(".","");
    var storeData = 
      `<div class="card-body body-2" id="`+obj.storeNumber+`">
        <div class="map-marker"><span>`+counter+`</span></div>            
        <div class="store-details" data-store-id="`+obj.storeNumber+`">
          <!--a href="/pages/`+storeHandle+`?id=`+obj.storeNumber+`" title="`+obj.storeName+`" tabindex="0"-->          
          <div class="store-distance store-distance-1">
            <span class="distance-miles">`+obj.distanceFromTarget+`</span>
            <span>Miles</span>
          </div>
          <a href="/pages/`+storeHandle+`" title="`+obj.storeName+`" tabindex="0">
            <div class="store-name" data-latitude="`+obj.storeLatitude+`" data-longitude="`+obj.storeLongitude+`">                  
              `+obj.storeName+`  
              <!--span class="text-red view-store-link">View</span-->
            </div>
          </a>
          <address>
            <div class="store-map"><i class="fa-light fa-location-dot"></i> `+obj.fullAddress+`</div>
            <!--div class="store-hours">Opening Hours: `+obj.monday+`</div-->
            <a href="/pages/`+storeHandle+`" class="learn-more link animate-arrow">Learn More <span class="icon-wrap"><svg viewBox="0 0 14 10" fill="none" aria-hidden="true" focusable="false" class="icon icon-arrow" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M8.537.808a.5.5 0 01.817-.162l4 4a.5.5 0 010 .708l-4 4a.5.5 0 11-.708-.708L11.793 5.5H1a.5.5 0 010-1h10.793L8.646 1.354a.5.5 0 01-.109-.546z" fill="currentColor"></path></svg></span></a>
          </address>
        </div>
      </div>`;  
    $('#search_stores_result .store-results').append(storeData);
    $('#search_stores_result').show();
    //$('#all_stores_list').hide();
  }
}